export const TEAM_ID_STORAGE_KEY = 'SELECTED_TEAM_ID';
export const FS_JWT_STORAGE_KEY = 'fs-jwt';
export const FS_REDIRECT_STORAGE_KEY = 'fs-redirect';
export const FS_MODAL_STATUS_STORAGE_KEY = 'fs-modal';